import { Standard } from '@getvim/vim-connect';

export const gender: Standard.Entities.Gender = Standard.Entities.Gender.female;
